import min from './min'
import max from './max'

export default ({ position, width }) =>
  `${(position / width) * (max - min) + min}`
